import { useMemo } from "react";
import { SELF_PACED_ROLES } from "../../../../helpers/utils/Constants/course";
import { LOCAL_STORAGE_KEYS } from "../../../../helpers/utils/Constants/keys";
import { RootStore, useAppSelector } from "../../../../store/store";

const MultiSelfPasedRoleNav = ({ navBg, normal, showfilter }: any) => {
  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const useRoles = authState?.tac_user?.all_roles;

  const allSelfUserRoles = useMemo(() => {
    // if useRoles then run this logic
    if (useRoles) {
      return useRoles.filter((role: any) => role !== "user");
    }
    return [];
  }, [useRoles]);

  const switchToSelfUser = (role: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.USER_TYPE, role);
    window.location.reload();
  };

  const getNameByValue = (value: string) => {
    const name = SELF_PACED_ROLES.find((role: any) => role.value === value);
    return name?.name;
  };

  return (
    <div
      className={`option__sections self_paced ${showfilter && "active"}  ${
        configState.themeMode === "light" && navBg && "light_mode"
      }  ${configState.themeMode === "light" && normal && "light_mode"}`}
    >
      {allSelfUserRoles.map((role: any) => {
        return (
          <span
            role="button"
            aria-hidden
            className={` option ${
              configState.themeMode === "light" && navBg && "light_mode"
            }  ${configState.themeMode === "light" && normal && "light_mode"}`}
            key={role}
            onClick={() => switchToSelfUser(role)}
          >
            {" "}
            {getNameByValue(role)}
          </span>
        );
      })}
    </div>
  );
};

export default MultiSelfPasedRoleNav;
